import { FilterModel, MultiSelect } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, FacetsConfig, SLOTS } from '@empathybroker/ebx-gluon';

const ALL_FACETS_GROUP = {
  productType_facet: {},
  hierarchical_category: {},
  state_facet: {},
  lang_facet: {},
  editorial_facet: {},
  externalScore_facet: {},
  price: {},
  collection_facet: {}
};

export const DEFAULT_MOBILE_FACETS: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      collapsible: true,
      components: {
        selectedFilters: null,
        filter: { checkbox: COMPONENTS.PURE.SolidCheckbox },
        icon: COMPONENTS.PURE.ChevronUpIcon
      }
    }
  },
  facets: {
    productType_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      }
    },
    state_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      }
    },
    editorial_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      }
    },
    externalScore_facet: {
      components: {
        filter: {
          title: 'CdlRatingCheckboxFilterTitle'
        }
      },
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      }
    },
    price: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend,
        filterModelName: FilterModel.currencyRange
      }
    },
    collection_facet: {
      mapping: {
        multiSelectable: MultiSelect.OnFrontend
      }
    },
  },
  groups: {
    'all-facets': {
      facets: ALL_FACETS_GROUP,
      slidingDirection: 'bottom',
      templateSlots: {
        panel: SLOTS.template.overlay
      },
      slots: {
        clear: SLOTS.facetsGroup.footer
      },
      components: {
        selectedFilters: {
          selectedFilters: COMPONENTS.PURE.SelectedFilters
        }, header: 'CdlFacetsTitle'
      }
    }
  }
};

export const DEFAULT_DESKTOP_FACETS: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      startCollapsed: true
    }
  },
  groups: {
    'all-facets': {
      facets: ALL_FACETS_GROUP,
      templateSlots: {
        panel: SLOTS.template.leftAside
      },
      collapsible: false,
      startCollapsed: false,
      components: {
        header: 'CdlFacetsTitle',
        clear: null
      }
    }
  }
};
